import React, { Component } from 'react';
import { Table, Form } from 'react-bootstrap';
import { concepts_payroll } from '../localdata/conceptos';


class ExtraHourForm extends Component {
    constructor(props) {
        super(props);
        this.myValueRef = React.createRef();
        this.myQuantityRef = React.createRef();
        this.state = {
            factor: 1
        };
    }
    componentDidMount() {
        const { concept } = this.props;
        const infoConcept = concepts_payroll.find((c) => c.code === concept)
        this.setState({ factor: (1 + (infoConcept.percentage / 100)) })
    }

    updateInfo = () => {
        const { valor_hora, returnData, concept } = this.props;

        const current_hour_value = (valor_hora) ? valor_hora : parseFloat(this.myValueRef.current.value);
        const current_quantity = (this.myQuantityRef.current.value !== '') ? parseFloat(this.myQuantityRef.current.value) : '';
        const valor_hora_final = current_hour_value * this.state.factor;
        const total_lin_ex = valor_hora_final * current_quantity;

        returnData({
            value: valor_hora_final,
            total_line: total_lin_ex,
            code: concept,
            quantity: current_quantity
        })
    }
    render() {
        const { valor_hora } = this.props;
        const tmpRefValue = (this.myValueRef.current && this.myValueRef.current.value !== '') ? this.myValueRef.current.value : 0
        const tmpRefQuantity = (this.myQuantityRef.current && this.myQuantityRef.current.value !== '') ? this.myQuantityRef.current.value : 0
        const current_hour_value = (valor_hora) ? valor_hora : parseFloat(tmpRefValue);
        const valor_hora_final = current_hour_value * this.state.factor;
        const total_lin_ex = valor_hora_final * tmpRefQuantity;
        return (
            <Table striped bordered>
                <thead>
                    <tr>
                        <td>TIPO</td>
                        <td>CANTIDAD</td>
                        <td>VALOR</td>
                        <td>TOTAL LINEA</td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{this.props.name}</td>
                        <td><Form.Control className='mediuminput' ref={this.myQuantityRef} type="number" min={0} placeholder="Ingrese la cantidad" name="quantity_extra" onChange={this.updateInfo}></Form.Control></td>
                        {
                            valor_hora
                                ? <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_hora_final)}</td>
                                : <td><Form.Control className='mediuminput' ref={this.myValueRef} type="number" min={0} name="local_value" value={this.state.local_value} onChange={this.updateInfo}></Form.Control></td>
                        }

                        <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_lin_ex)}</td>
                    </tr>
                </tbody>
            </Table>
        );
    }
}
export default (ExtraHourForm);


// WEBPACK FOOTER //
// ./src/components/nomina/subcomponents/extraHoursForm.jsx